module.exports = __webpack_public_path__ + "static/media/Logo-Footer.5032214a.png";